import { useDispatch, useSelector } from 'react-redux';
import { setLoading } from '../containers/user-container/reducer/userSlice';

const useLoader = () => {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.user.loading);

  const startLoading = () => {
    dispatch(setLoading(true));
  };

  const stopLoading = () => {
    dispatch(setLoading(false));
  };

  return {
    loading,
    startLoading,
    stopLoading,
  };
};

export default useLoader;
